"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrideTheme = void 0;
var lodash_merge_1 = __importDefault(require("lodash.merge"));
/**
 * This function allows the users to override the base theme with project level overrides.
 * @param themeOverrides
 */
function overrideTheme(themeObj, themeOverrides) {
    return (0, lodash_merge_1.default)(themeObj, themeOverrides);
}
exports.overrideTheme = overrideTheme;
